// 模型值常量（直接使用数字）
export const MODEL_ENUM = {
  NORMAL_DISTRIBUTION: 0,
  SLOPE: 1,
} as const

// 模型配置 - 唯一数据源
export const MODEL_CONFIG = [
  { value: MODEL_ENUM.NORMAL_DISTRIBUTION, label: '正态分布模型', classTagName: 'nomal-tagbgc-blue' },
  { value: MODEL_ENUM.SLOPE, label: '斜率模型', classTagName: 'nomal-tagbgc-purple' },
] as const

// 从配置派生：模型类型映射（用于表格展示）
export const MODEL_TYPE_MAP = MODEL_CONFIG.reduce((acc, item) => {
  acc[item.value] = item.label
  return acc
}, {} as Record<number, string>)

// 从配置派生：模型类型映射（用于标签颜色）
export const MODEL_CLASS_MAP = MODEL_CONFIG.reduce((acc, item) => {
  acc[item.value] = item.classTagName
  return acc
}, {} as Record<number, string>)

export const tableColumn = [
  {
    title: '阈值方案名称',
    dataIndex: 'schemeName',
    key: 'schemeName',
    width: '170px',
  },
  {
    title: '已选模型',
    dataIndex: 'modelConfig',
    key: 'modelConfig',
    width: '150px',
  },
  {
    title: '产品',
    dataIndex: 'dbtIds',
    key: 'dbtIds',
    width: '130px',
  },
  {
    title: '日订单量级',
    dataIndex: 'scale',
    key: 'scale',
    width: '100px',
  },
  {
    title: '状态',
    dataIndex: 'enable',
    key: 'enable',
    width: '90px',
  },
  {
    title: '创建人',
    dataIndex: 'createUser',
    key: 'createUser',
    width: '110px',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: '130px',
  },
  {
    title: '方案描述',
    dataIndex: 'remark',
    key: 'remark',
    width: '150px',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    align: 'right',
    width: '135px',
    fixed: 'right',
  },
]
